import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { MessengerItem } from '../_models/MessengerItem';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class MessengerService {
baseUrl = "https://assessorchat.lacounty.gov/api/dialog/"
messengerInfo: MessengerItem;
constructor(private http: HttpClient) { }



getMessage(content: any, id: string){
  console.log(id);

  return this.http.post<Message>(this.baseUrl + id, content);
}

createThread(content: any) {
  return this.http.post<MessengerItem>(this.baseUrl, content)
    .pipe(
      map((response: any) => {
        const thread = response;
        if (thread) {
          this.messengerInfo = thread;
          console.log(this.messengerInfo)
        }
      })
    );
}

}

export interface Message {
  id: number
  type: string
  content: string
  isRead: boolean
  dateRead: any
  messageSent: string
  isBot: boolean
  isMapRequest: boolean
  latitude: number
  longitude: number
}
